import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_URL } from './config/apiConfig';
import { resolvePublicAssetUrl } from './utils/resolvePublicAssetUrl';
import './WelcomeExploreUnknownLeaderboard.css';
import './WelcomeLeftStack.css';

const POLL_MS = 30000;

/**
 * @param {{ isMobile?: boolean }} props
 */
function WelcomeLatestRemnants({ isMobile = false }) {
  const { t } = useTranslation();
  const [remnants, setRemnants] = useState([]);
  const [fetchFailed, setFetchFailed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadRemnants = async () => {
      try {
        const response = await fetch(`${API_URL}/welcome/latest-remnants`);
        if (!response.ok) {
          const errText = await response.text().catch(() => response.statusText);
          throw new Error(`latest-remnants HTTP ${response.status}: ${errText}`);
        }
        const data = await response.json();
        if (!Array.isArray(data.remnants)) {
          throw new Error('latest-remnants response missing remnants array');
        }
        if (!cancelled) {
          setRemnants(data.remnants);
          setFetchFailed(false);
          setLoading(false);
        }
      } catch (err) {
        console.error('Welcome: latest-remnants fetch failed:', err);
        if (!cancelled) {
          setFetchFailed(true);
          setLoading(false);
        }
      }
    };

    loadRemnants();
    const id = setInterval(loadRemnants, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return (
    <aside
      className={`welcome-eu-leaderboard welcome-latest-remnants${isMobile ? ' welcome-eu-leaderboard--mobile' : ''}`}
      aria-label={t('welcome.latestRemnants.ariaLabel')}
    >
      <div className="welcome-eu-leaderboard__safe-area">
      <span className="welcome-eu-leaderboard-corner welcome-eu-leaderboard-corner--tr" aria-hidden="true" />
      <span className="welcome-eu-leaderboard-corner welcome-eu-leaderboard-corner--br" aria-hidden="true" />
      <div className="welcome-eu-leaderboard-header">
        <img
          src={resolvePublicAssetUrl('/factions/remnants.png')}
          alt=""
          className="welcome-eu-leaderboard-icon"
          aria-hidden="true"
        />
        <h2 className="welcome-eu-leaderboard-title">{t('welcome.latestRemnants.title')}</h2>
      </div>

      {loading && remnants.length === 0 && !fetchFailed && (
        <p className="welcome-eu-leaderboard-status">{t('welcome.latestRemnants.loading')}</p>
      )}

      {fetchFailed && remnants.length === 0 && (
        <p className="welcome-eu-leaderboard-status welcome-eu-leaderboard-status--error">
          {t('welcome.latestRemnants.loadFailed')}
        </p>
      )}

      {!fetchFailed && !loading && remnants.length === 0 && (
        <p className="welcome-eu-leaderboard-status">{t('welcome.latestRemnants.empty')}</p>
      )}

      {remnants.length > 0 && (
        <ol className="welcome-eu-leaderboard-list welcome-eu-leaderboard-list--scroll">
          {remnants.map((remnant) => (
            <li
              key={remnant.username}
              className="welcome-eu-leaderboard-entry welcome-eu-leaderboard-entry--compact"
            >
              <div className="welcome-eu-leaderboard-body">
                <div className="welcome-eu-leaderboard-player">{remnant.username}</div>
              </div>
            </li>
          ))}
        </ol>
      )}
      </div>
    </aside>
  );
}

export default WelcomeLatestRemnants;
